import { ServiceCard } from './ServiceCard';

const tenantItems = [
  'Maintenance Requests',
  'Feedback Requests',
  'Tenant Application',
  'Credit Check',
  'Background Check',
  'Reference Check',
  'Employment Verification',
  'Rent Collection',
];

const landlordItems = [
  'Monthly Property Statements',
  'Annual Performance Report',
  'Annual Tax Documentation',
  'Repair Invoices and Receipts',
  'Rent Dispersal',
  'Tenant Evictions',
  'Tenant Procurement/Screening',
  'Obtaining 3rd-party Repair Bids',
];

const propertyItems = [
  'Repairs',
  'Maintenance and Upkeep',
  'Advertising',
  'Leasing',
  'Market Rent Analysis',
  'Property Condition Inspections',
  'Video Before Tenancy',
  'Video After Tenancy',
];

export function ManagementCards() {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
      <ServiceCard
        title="For Tenants"
        imageSrc="/static/images/management-tenants.jpg"
        imageAlt="For Tenants"
        items={tenantItems}
        buttonLabel="Tenant Portal"
        buttonHref="https://marshallreddick.appfolio.com/connect"
      />
      <ServiceCard
        title="For Landlords"
        imageSrc="/static/images/management-landlords.jpg"
        imageAlt="For Landlords"
        items={landlordItems}
        buttonLabel="Landlord Portal"
        buttonHref="https://marshallreddick.appfolio.com/oportal"
      />
      <ServiceCard
        title="For Properties"
        imageSrc="/static/images/management-building.jpg"
        imageAlt="For Properties"
        items={propertyItems}
        buttonLabel="Browse Homes For Rent"
        buttonHref="/rentals"
      />
    </div>
  );
}
